// @ts-check
import {useCallback, useEffect, useRef, useState} from "react"
import {useWindowEvent} from "./useWindowEvent"

const eventListerOptions = {
  passive: true,
}

const defaultState = {
  isMobile: false,
  isTablet: false,
  isDesktop: false,
}

/**
 * for global cache
 * @type {string=}
 */
let lastBreakpoint = undefined

function getStaleState() {
  if (lastBreakpoint) {
    return {...defaultState, [lastBreakpoint]: true}
  } else {
    return defaultState
  }
}

export function useBreakpoint() {
  // this hook latest used breakpoint
  const prevUsedBreakpoint = useRef(/** @type {string=} */ (undefined))
  const [breakpoint, setBreakpoint] = useState(getStaleState())

  const updateBreakpoint = useCallback(() => {
    const width = window.innerWidth || 0

    const currentBreakpoint =
      width >= 1280 ? "isDesktop" : width >= 768 ? "isTablet" : "isMobile"
    // console.log({width, currentBreakpoint, lastBreakpoint})

    if (!lastBreakpoint || lastBreakpoint !== currentBreakpoint) {
      lastBreakpoint = currentBreakpoint
    }
    if (prevUsedBreakpoint.current !== lastBreakpoint) {
      prevUsedBreakpoint.current = lastBreakpoint
      setBreakpoint({
        ...defaultState,
        [lastBreakpoint]: true,
      })
    }
  }, [])

  useWindowEvent("resize", updateBreakpoint, eventListerOptions)
  useWindowEvent("orientationchange", updateBreakpoint, eventListerOptions)

  useEffect(() => {
    prevUsedBreakpoint.current = undefined
  }, [])

  useEffect(() => {
    updateBreakpoint()
  }, [updateBreakpoint])

  return breakpoint
}
